export class EdgeRouterPolicy {
    name = '';
    edgeRouterRoles: any[] = [];
    identityRoles: any[] = [];
    semantic = 'AnyOf';
    tags: any = {}
};